const DEFAULT_TZ = "Europe/Berlin";

function toDate(input) {
  if (!input) return null;
 if (input instanceof Date) return Number.isNaN(input.getTime()) ? null : input;
  const d = new Date(input);
 return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDateTimeDE(input, { withWeekday = false, timeZone = DEFAULT_TZ } = {}) {
  const d = toDate(input);
  if (!d) return "";
  const datePart = new Intl.DateTimeFormat("de-DE", {
    timeZone,
    weekday: withWeekday ? "long" : undefined,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(d);
  const timePart = new Intl.DateTimeFormat("de-DE", {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(d);
  return `${datePart} ${timePart}`;
}

export function formatDateTimeDELong(input, { timeZone = DEFAULT_TZ } = {}) {
  const d = toDate(input);
  if (!d) return "";
  const datePart = new Intl.DateTimeFormat("de-DE", {
    timeZone,
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(d);
  const timePart = new Intl.DateTimeFormat("de-DE", {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(d);
  return `${datePart} um ${timePart} Uhr`;
}

export function formatDateDE(input, { timeZone = DEFAULT_TZ } = {}) {
  const d = toDate(input);
  if (!d) return "";
  return new Intl.DateTimeFormat("de-DE", {
    timeZone,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(d);
}

export function formatTimeDE(input, { timeZone = DEFAULT_TZ } = {}) {
  const d = toDate(input);
  if (!d) return "";
  return new Intl.DateTimeFormat("de-DE", {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(d);
}


